import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupByReportService {



  url = environment.serverAPI9 + "/api/group";

   url1 = environment.serverAPI9 + "/api/source/user/report";

   url2 = environment.serverAPI9 + "/api/status/user/report";

    url3 = environment.serverAPI9 + "/api/deals/group";
  
  customReportUrl = environment.serverAPI9 + "/api/reports/custom";

  constructor(private http: HttpClient) { }

  getCustomDynamicReport(payload: any): Observable<any> {
    return this.http.post<any>(this.customReportUrl, payload);
  }

  searchDynamicLeadReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }
   searchDynamicLeadReporttwo(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url3}/condition${queryParams}`, requestBody);
  }


  getUserWiseSourceReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url1}${queryParams}`, requestBody);
  }


  getUserWiseStatusReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url2}${queryParams}`, requestBody);
  }


    getLeadGroupReportNew(
    searchRequest: any,
    page: number,
    size: number
  ): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', 'updatedDate,desc');

    return this.http.post<any>(this.url1, searchRequest, { params });
  }

    dynamicLeadOwnerReport(query: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    return this.http.post<Response[]>(`${this.url}/condition/list`, requestBody);
  }

}

